import { useState } from 'react';

import { faThumbtack as faThumbtackRegular } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import {
  faThumbTackSlash,
  faThumbtack,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@repo/videa-components/src/lib/utils';
import type { Row } from '@tanstack/react-table';

import type { TProviderTreatment } from '@/react-query/insights/types';
import {
  useCreateProviderPin,
  useDeleteProviderPin,
} from '@/react-query/insights/useInsightsPinning';

export const RecommendationPinCell = ({
  row,
  hoveredRowId,
}: {
  row: Row<TProviderTreatment>;
  hoveredRowId?: string | null;
}) => {
  const { mutate: deletePin } = useDeleteProviderPin();
  const { mutate: createPin } = useCreateProviderPin();
  const hasPin = !!row.original.recommendationPinId;
  const isHovered = hoveredRowId === row.id;
  const isVisible = hasPin || isHovered;
  const [isIconHovered, setIsIconHovered] = useState(false);

  return (
    <div className="vai-w-6 vai-h-6 vai-flex vai-items-center vai-justify-center">
      <FontAwesomeIcon
        icon={
          hasPin && isIconHovered
            ? faThumbTackSlash
            : hasPin
              ? faThumbtack
              : faThumbtackRegular
        }
        className={cn(
          'vai-h-4 vai-w-4',
          hasPin
            ? 'vai-text-gray-500'
            : isHovered
              ? 'vai-text-gray-500 vai-opacity-100'
              : 'vai-text-gray-300 vai-opacity-0',
          isVisible && 'vai-cursor-pointer',
        )}
        onClick={
          isVisible
            ? (e) => {
                e.stopPropagation();
                if (hasPin) {
                  // Hide the pin
                  row.original.recommendationPinId = null;
                  deletePin({
                    pmsProviderId: row.original.pmsProviderId.toString(),
                    pmsPatientId: row.original.pmsPatientId.toString(),
                    apptDate: (row.original.apptDate instanceof Date
                      ? row.original.apptDate
                      : new Date(row.original.apptDate)
                    )
                      .toISOString()
                      .split('T')[0],
                    featureName: row.original.suggestionType,
                    tooth: row.original.tooth,
                  });
                } else {
                  // Show the pin
                  row.original.recommendationPinId = Math.random()
                    .toString(36)
                    .substring(2, 15);
                  createPin({
                    pmsProviderId: row.original.pmsProviderId.toString(),
                    pmsPatientId: row.original.pmsPatientId.toString(),
                    apptDate: (row.original.apptDate instanceof Date
                      ? row.original.apptDate
                      : new Date(row.original.apptDate)
                    )
                      .toISOString()
                      .split('T')[0],
                    featureName: row.original.suggestionType,
                    tooth: row.original.tooth,
                  });
                }
              }
            : undefined
        }
        onMouseEnter={() => setIsIconHovered(true)}
        onMouseLeave={() => setIsIconHovered(false)}
        tabIndex={isVisible ? 0 : -1}
        role="button"
        aria-label="Pin"
      />
    </div>
  );
};
